import { useTranslation } from "react-i18next";

import { IconEdit01, IconFileAttachment01 } from "@pentabd/icons";
import { Text } from "@pentabd/ui";

import { ErrorModal, StatusBadge, SuccessModal } from "@components";

import { useUser } from "@hooks/useUser";

// import { getAccess } from "@helpers/permissionController";

import {
  AssigneeFile,
  FileInquiryFlow,
  InquiryFile,
} from "@type/HRM/fileInquiry";
import { useState } from "react";
import { FileInquiryModal } from "./FileInquiryModal";
import { useFunctionalityData } from "@hooks/useFunctionalityData";
import { FUNCTIONALITY_DATA } from "@constants/functionality-data";
import { FormProvider, useForm } from "react-hook-form";
import { fileInquiryFlow } from "@api/fileInquiry";

interface TableColumnPropType {
  isProfileDisabled: boolean;
  fetchSingleFileInquiry?: (id: number) => void;
  handleEditMode?: (isEdit: boolean) => void;
}

const { APPROVAL_MATRIX } = FUNCTIONALITY_DATA;

export const TableColumn = ({
  isProfileDisabled,
  fetchSingleFileInquiry,
  handleEditMode,
}: TableColumnPropType) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { user } = useUser();
  const { realm_roles: roles, employeeMasterId } = user || {};
  const { data: designation } = useFunctionalityData(APPROVAL_MATRIX);
  const methods = useForm();
  return [
    {
      id: 1,
      key: "enquiryFile",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.FILE_TYPE"),
      render: (enquiryFile: InquiryFile) => (
        <Text color="subtitle2" className="text-nowrap">
          {enquiryFile?.fileType}
        </Text>
      ),
    },
    {
      id: 2,
      key: "enquiryFile",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.SUBJECT"),
      render: (enquiryFile: InquiryFile) => <Text>{enquiryFile?.subject}</Text>,
    },
    {
      id: 3,
      key: "fileFromDate",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.FILE_FROM_DATE"),
      render: (fileFromDate: string) => (
        <Text size="sm" weight="normal" color="subtitle2">
          {fileFromDate}
        </Text>
      ),
    },
    {
      id: 4,
      key: "performanceEvaluation",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.PERFORMANCE_EVALUATION"),
      render: (performanceEvaluation: string) => (
        <Text size="sm" weight="normal" color="info">
          {performanceEvaluation}
        </Text>
      ),
    },
    {
      id: 5,
      key: "status",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 6,
      key: "id",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.EDIT"),
      render: (_id: number, row: AssigneeFile) =>
        !isProfileDisabled &&
        (employeeMasterId === row?.assignee?.id?.toString() ||
          employeeMasterId === row?.assigner?.id?.toString()) ? (
          <IconEdit01
            className="cursor-pointer"
            size={20}
            color="primary"
            onClick={() => {
              if (fetchSingleFileInquiry) {
                fetchSingleFileInquiry(row?.enquiryFile?.id);
                handleEditMode?.(true);
                //scroll to bottom
                const element = document.getElementById("file-inquiry-form");
                if (element) {
                  element.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                  });
                }
              }
            }}
          />
        ) : (
          <></>
        ),
    },
    {
      id: 7,
      key: "id",
      name: t("EMPLOYEE.FILE_INQUIRY.TABLE.COLUMN.SEND_FOR_APPROVAL"),
      render: (_id: number, row: AssigneeFile) => {
        return !isProfileDisabled &&
          employeeMasterId === row?.assignee?.id?.toString() ? (
          <FormProvider {...methods}>
            {/* MODAL SECTION */}
            <>
              <SuccessModal
                isModalOpen={isSuccessModalOpen}
                action={() => {
                  setIsSuccessModalOpen(false);
                }}
              />
              <ErrorModal
                isModalOpen={isErrorModalOpen}
                closeModal={() => setIsErrorModalOpen(false)}
              />
            </>
            {/* MODAL SECTION */}
            <IconFileAttachment01
              className="cursor-pointer"
              size={20}
              color="primary"
              onClick={() => {
                setIsModalOpen(true);
              }}
            />
            <FileInquiryModal
              employeeName={row?.assignee?.nameEn}
              isModalOpen={isModalOpen}
              designation={designation}
              onClose={() => setIsModalOpen(false)}
              gradeId={10}
              isLoading={isLoading}
              handleSendForApproval={(data: FileInquiryFlow) => {
                setIsLoading(true);
                fileInquiryFlow(
                  row?.id?.toString(),
                  {
                    ...data,
                    returnedId: Number(employeeMasterId),
                    status: "RETURNED",
                  },
                  (response) => {
                    if (response.status === "success") {
                      setIsModalOpen(false);
                      setIsSuccessModalOpen(true);
                      setIsModalOpen(false);
                    } else {
                      setIsErrorModalOpen(true);
                    }
                    setIsLoading(false);
                  },
                );
              }}
            />
          </FormProvider>
        ) : (
          <></>
        );
      },
    },
  ];
};
